import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Heart, ArrowRight, Shield, FileCheck, Activity, Clock } from 'lucide-react';

const Healthcare = () => {
  const solutions = [
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Medical Asset Tracking',
      description: 'Track equipment, supplies, and medications with precision'
    },
    {
      icon: <FileCheck className="w-8 h-8" />,
      title: 'Compliance Management',
      description: 'Automated documentation and regulatory compliance'
    },
    {
      icon: <Activity className="w-8 h-8" />,
      title: 'Temperature Monitoring',
      description: 'IoT-enabled monitoring for sensitive medical supplies'
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: 'Expiry Management',
      description: 'Automated alerts for medication and supply expiration'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center mb-6">
            <Heart className="w-16 h-16 text-blue-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Healthcare Solutions</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto text-center">
            Improve patient care and operational efficiency with healthcare-specific tracking solutions
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Healthcare-Specific Solutions</h2>
            <p className="text-lg text-slate-600">Technology designed for healthcare environments</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {solutions.map((solution, index) => (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    <div className="p-3 bg-blue-100 rounded-lg text-blue-600">
                      {solution.icon}
                    </div>
                    <CardTitle className="text-xl">{solution.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-600">{solution.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-blue-600 to-cyan-600 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Enhance Healthcare Operations</h2>
          <p className="text-xl mb-8 text-blue-100">
            Let's discuss how we can support your healthcare facility
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-slate-100 px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Contact Us <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Healthcare;